import React, { Component } from 'react';
import _ from 'lodash';
import AddressForm from './address_form';

export default class AdddressesForm extends Component {
  componentDidMount() {
    this.updateAddresses(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.updateAddresses(nextProps);
  }

  updateAddresses(props) {
    this.setState({ addresses: _.cloneDeep(this.props.addresses) });
  }

  onAddressAction = (action, index) => {
    const { addresses } = this.state;
    switch (action) {
      case 'add':
        return this.setState({ addresses: _.concat(addresses, {}) });
      case 'delete':
        if (!addresses[index].id) {
          return this.setState({ addresses: _.reject(addresses, (a, i) => i === index) });
        }
        return this.setState({ addresses: _.set(_.cloneDeep(addresses), [index, 'deleted'], true) });
    }
  }

  onScheduleSelect = (address, index, day, time, value) => {
    const addresses = _.cloneDeep(this.state.addresses);
    _.set(addresses, [index, 'schedule', day, time], value);
    if (value) {
      _.forEach(addresses, (address, i) => i !== index ? _.set(address, ['schedule', day, time], false) : null);
    }
    this.setState({ addresses: addresses });
  }

  render() {
    if (!this.state) { return null; }
    const { addresses } = this.state;
    return (
      <div>
        {_.map(addresses, (address, index) => (
          address.deleted
          ? (
            <div className="hide" key={index}>
              <input type="hidden" name={`student[addresses_attributes][${index}][id]`} value={address.id} />
              <input type="hidden" name={`student[addresses_attributes][${index}][_destroy]`} value={true} />
            </div>
          ) : (
            <AddressForm
              key={index}
              address={address}
              index={index}
              action={index === addresses.length - 1 ? 'add' : 'delete'}
              onActionClick={this.onAddressAction}
              onScheduleSelect={this.onScheduleSelect}
            />
          )
        ))}
      </div>
    );
  }
}
